<template>
  <div id="app" v-if="isAuthenticated" :style="getColorSettings" :class="{ 'dark-theme': isDarkTheme }">
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { bus } from './main';
import Vue from 'vue';
import Toasted from 'vue-toasted';
import 'cropperjs/dist/cropper.css';
import './assets/scss/nprogress.scss';
import common from './helpers/common';
console.log('app.vue');

export default {
	  name: 'App',
	  data() {
	    return {
	      isAuthenticated: false,
	      calendar: '',
	      color: '',
	      isDarkTheme: false,
	    };
	  },
	  computed: {
	    getColorSettings() {
      const color = common.getSafeColor(this.$route.query.color);

	      return {
	        '--primary-color': color,
	      };
	    },
	  },
	  methods: {
	    ...mapActions('common', ['getUserParams']),
	    ...mapActions('lives', ['setCurrentLang']),
	    applyTheme(theme) {
	      const body = document.body;
	      const html = document.documentElement;

	      body.classList.remove('dark-theme', 'light-theme', 'dark-mode', 'light-mode');
	      html.classList.remove('dark-theme', 'light-theme', 'dark-mode', 'light-mode');

	      if (theme === 'dark') {
	        this.isDarkTheme = true;
	        body.classList.add('dark-theme');
	        html.classList.add('dark-theme');

	        body.style.backgroundColor = '#1e1e1e';
	        body.style.color = '#e0e0e0';
	        html.style.backgroundColor = '#1e1e1e';
	      } else {
	        this.isDarkTheme = false;
	        body.classList.add('light-theme');
	        html.classList.add('light-theme');

	        body.style.backgroundColor = '#ffffff';
	        body.style.color = '#212121';
	        html.style.backgroundColor = '#ffffff';
	      }
	    },
	    handleThemeMessage(event) {
	      if (event.data && event.data.info === 'updateTheme') {
	        const theme = event.data.theme;
	        this.applyTheme(theme);
	        localStorage.setItem('theme', theme);
	      }

	      if (event.data && event.data.info === 'clearTheme') {
	        localStorage.removeItem('theme');
	        // this.applyTheme('light');
	      }
	    },
	    eventPostMessage() {
	      let self = this;
	      let code = 'fr';
	      let router = this.$router;
      if (window.dataEventPostMessage === undefined) {
        window.dataEventPostMessage = true;
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
        eventer(
          messageEvent,
          function(event) {
            var message = event.data;
            if (message !== 'undefined') {
              if (message.info === 'updateLang') {
                code = message.lang;
                Vue.use(Toasted, {
                  iconPack: 'custom-class',
                });
                bus.$emit('setFormLang', code);
                self.$root.$emit('setFormLang', code);
                self.$root.$emit('setCalendarLang', code);
                self.setCurrentLang(code);
              }
                if (message.info === 'redirectListLive') {
                    const cryptext = router.query;
                    router.push({ name: 'ListLive', query: cryptext });
                }
            }
          },
          false,
        );
      }
    },
	  },
	  async created() {
	    const cryptext = this.$route.query.cryptext;
	    window.addEventListener('message', this.handleThemeMessage);

	    const urlParams = new URLSearchParams(window.location.search);
	    const defaultTheme = urlParams.get('dark') === 'true' ? 'dark' : 'light';
	    const savedTheme = localStorage.getItem('theme') || defaultTheme;
	    this.applyTheme(savedTheme);

	    try {
	      await this.getUserParams(cryptext);
	      this.isAuthenticated = true;
    } catch (e) {
      console.error(e);
    }
  },
	  mounted() {
	    this.$nextTick(() => {
	      this.eventPostMessage();
	    });
	  },
	  beforeDestroy() {
	    window.removeEventListener('message', this.handleThemeMessage);
	  },
	};
</script>

<style lang="scss">
@import '@/assets/scss/_theme.scss';
@import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css';
@import 'vue-multiselect/dist/vue-multiselect.min.css';

#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text);
  background-color: var(--background);
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue